const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_USER_POOL_ID || 'us-east-1_JzFujYB2Q',
      userPoolClientId: process.env.REACT_APP_CLIENT_ID || '6604ttc5epha669rvpu9m4h5n1',
      loginWith: {
        email: true,
      },
    },
  },
};

export default awsConfig;
